/* 太史慈傳・第 2 章：涇縣（195–196 年）
 * 涇縣山中。中間是太史慈立的屯府（帳篷），東、西、東南各一處山越的寨子；西南角是進深山的山口。
 * 孫策的兵從北、東北、西北三條山路下來。 */
export const FU = [3800, 2500], EAST = [6300, 2000], WEST = [1100, 2700], SOUTH = [5600, 4200], PASS = [1000, 4700];
export const ENTRIES = [[3800, 250], [7200, 500], [700, 450]]; // 孫軍來的三條路：北、東北、西北
export const SHOOT = [1700, 2400], TARGETS = [[1450, 2080], [1700, 2050], [1950, 2080]]; // 西寨：射線與三個「的」
export default {
  id: 'taishici_jingxian', name: '涇縣', W: 7600, H: 5200, seed: 1951,
  bases: [FU, ENTRIES[0]],
  roads: [
    { pts: [FU, [3800, 1300], ENTRIES[0]], w: 130 },
    { pts: [FU, [5000, 2200], EAST], w: 110 }, { pts: [EAST, [6800, 1200], ENTRIES[1]], w: 110 },
    { pts: [FU, [2500, 2500], SHOOT, WEST], w: 110 }, { pts: [SHOOT, [1500, 1300], ENTRIES[2]], w: 110 },
    { pts: [FU, [4700, 3500], SOUTH], w: 110 },
    { pts: [FU, [3000, 3500], [2000, 4200], PASS], w: 110 },
  ],
  rocks: [[2600, 900, 500, 240], [5200, 900, 460, 220], [5100, 3200, 300, 160], [2300, 3300, 360, 180], [6700, 3300, 420, 200], [3500, 4500, 500, 220], [500, 3600, 300, 300], [600, 4300, 260, 160], [1600, 5000, 380, 150], [7200, 4600, 300, 200]],
  woods: 0.55,
  sight: 0.8,
  clearings: [[FU[0], FU[1], 700], [EAST[0], EAST[1], 450], [WEST[0], WEST[1], 420], [SOUTH[0], SOUTH[1], 420], [PASS[0], PASS[1], 260], [1700, 2200, 420]],
  villages: [{ x: EAST[0] + 100, y: EAST[1] - 150, n: 5, r: 300 }, { x: WEST[0] - 150, y: WEST[1] + 100, n: 4, r: 260 }, { x: SOUTH[0] + 100, y: SOUTH[1] + 100, n: 5, r: 300 }],
  tents: [{ x: FU[0], y: FU[1] - 80, n: 7, r: 380, chief: true, col: '#5a6a3a', flag: '丹' }],
  grass: [[4400, 1600, 220, 100], [3000, 3000, 220, 100], [5200, 4400, 200, 90], [2600, 4300, 240, 110]],
  palette: { grass: [70, 88, 52] },
};
